package com.devi3east.bashbuddy.search.ui.components

import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable

@Composable
fun StateFilterSheet(
    states: List<String>,
    onApply: (String) -> Unit,
    onDismiss: () -> Unit
) {
    FilterBottomSheet(
        title = "Select State",
        onDismiss = onDismiss
    ) {
        states.forEach { state ->
            TextButton(
                onClick = { onApply(state) },
            ) {
                Text(state)
            }
        }
    }
}